/**
 * Custom Tags filter matcher (My Vendors tab).
 * A vendor passes when their tag list contains ANY of the selected tags (OR within section).
 */
export function vendorMatchesCustomTagFilter(vendorTags = [], selectedTags = []) {
  if (!selectedTags?.length) return true;
  if (!vendorTags?.length) return false;
  const vendorLower = new Set(vendorTags.map((t) => String(t).toLowerCase()));
  return selectedTags.some((tag) => vendorLower.has(String(tag).toLowerCase()));
}

/**
 * Vendor Lists tab matcher: list passes when ANY vendor carries ANY selected tag.
 */
export function vendorListMatchesCustomTagFilter(
  listVendorTagsLists = [],
  selectedTags = []
) {
  if (!selectedTags?.length) return true;
  return listVendorTagsLists.some((tags) =>
    vendorMatchesCustomTagFilter(tags, selectedTags)
  );
}
